export const QUILL_MODULES = {
  toolbar: [
    [{ size: ['small', false, 'large', 'huge'] }],
    [{ color: [] }],
    [{ font: [] }],

    [{ header: [1, 2, 3] }],
    ['bold', 'italic', 'underline'],
    ['blockquote'],

    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '+1' }, { indent: '-1' }],
    ['link'],
  ],
};

// Applied by ngx-quill right after it lazy-loads Quill and before any editor is
// created, so the app does not need a static `import Quill from 'quill'`.
export const QUILL_CUSTOM_OPTIONS = [
  {
    import: 'formats/font',
    whitelist: [
      'sans-serif',
      'serif',
      'monospace',
      'roboto',
      'open-sans',
      'lato',
      'montserrat',
      'poppins',
    ],
  },
];

export const QUILL_FORMATS = [
  'background',
  'bold',
  'color',
  'font',
  'code',
  'italic',
  'link',
  'size',
  'strike',
  'script',
  'underline',
  'blockquote',
  'header',
  'indent',
  'list',
  'align',
  'direction',
  'code-block',
  'formula',
];
